import * as React from 'react';
import './promotionPanel.css';

class PromotionPanel extends React.Component {
    public render() {
      return (   
          <div className="app-promotion-panel">
            FREE SHIPPING ON ORDERS OF $75+
          </div>
      );
    }
  }
  
  export default PromotionPanel;
  


// WEBPACK FOOTER //
// ./src/components/promotionPanel/promotionPanel.tsx